module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedLight.f2d8617.woff2";